module.exports = __webpack_public_path__ + "static/gel-8e2a772aef8b85d7778da52086841f1b.png";